// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const oinkologne_male: PokeData = {
  "id": 916,
  "name": "oinkologne-male",
  "height": 10,
  "weight": 1200,
  "base_experience": 171,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "tail-whip",
    "dig",
    "uproar",
    "yawn",
    "mud-shot",
    "covet",
    "earth-power",
    "echoed-voice",
    "work-up",
    "belch",
    "disarming-voice"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "mud-shot",
    "earth-power",
    "tri-attack",
    "scary-face",
    "refresh",
    "body-slam",
    "growl",
    "scratch",
    "quick-attack",
    "protect",
    "leer"
  ],
  "evolution_chain": {
    "id": 481,
    "item": null,
    "species": [
      {
        "name": "lechonk",
        "order": 915,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "oinkologne",
        "order": 916,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 915,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 145,
    "speed": 100,
    "ability_power": 155
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
